var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontalBarChartWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17290",
    transform: "translate(534 300)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h30v30H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1417",
    transform: "translate(-534 -300)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17289",
    fill: "none",
    d: "M534 300h30v30h-30z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21569",
    d: "M537.75 302.5a1.25 1.25 0 0 1 1.25 1.25v22.5a1.25 1.25 0 0 1-1.25 1.25 1.25 1.25 0 0 1-1.25-1.25v-22.5a1.25 1.25 0 0 1 1.25-1.25Zm3.75 18.75v2.5h10a1.25 1.25 0 0 0 1.25-1.25 1.25 1.25 0 0 0-1.25-1.25Zm0-15v2.5h18.75a1.25 1.25 0 0 0 1.25-1.25 1.25 1.25 0 0 0-1.25-1.25Zm0 10v2.5h13.75a1.25 1.25 0 0 0 1.25-1.25 1.25 1.25 0 0 0-1.25-1.25Zm0-5v2.5h8.125a1.25 1.25 0 0 0 1.25-1.25 1.25 1.25 0 0 0-1.25-1.25Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalBarChartWhite);
export default __webpack_public_path__ + "static/media/horizontal-bar-chart-white.72fe62a134da0dc711c8ab7e20fbb72a.svg";
export { ForwardRef as ReactComponent };